import { render, staticRenderFns } from "./setTeacher.vue?vue&type=template&id=def6187c&scoped=true"
import script from "./setTeacher.vue?vue&type=script&lang=js"
export * from "./setTeacher.vue?vue&type=script&lang=js"
import style0 from "./setTeacher.vue?vue&type=style&index=0&id=def6187c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def6187c",
  null
  
)

export default component.exports